import Disclaimer from "~/pages/schnelltest/partials/Disclaimer";

export function ExitMieterhoehungIndexmieteUnterInflationsrate() {
  return (
    <>
      <h2>Die Mieterhöhung ist wahrscheinlich rechtmäßig</h2>
      <p>TODO</p>
      <h3>Was nun?</h3>
      <p>Bitte überprüfe zunächst, ob die folgenden Angaben stimmen:</p>
      <ol>
        <li>Item</li>
      </ol>
      <Disclaimer />
    </>
  );
}
